import { CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';

export const devEnvironmentGuard: CanActivateFn = () => {
    return !environment.production;
};
